import React from "react";
import ReactDOM from "react-dom/client"; // react-dom v18 이상
import App from "./App";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
